document.addEventListener('turbolinks:load', () => {
  const path = document.location.pathname;
  if (path.match(/^\/snow\/articles/)) {
    $('.markdown__toc').find('a').on('click', (e) => {
      e.preventDefault();
      const id = $(e.target).attr('href');
      const target = $(id).offset().top;
      const marginTop = parseInt($(id).css('margin-top'), 10);
      const offSet = 10;
      window.scroll({
        top: target - marginTop - offSet,
        left: 0,
      });
    });
  }
});
